import axios from "axios";
import { BACKEND_HOST } from "../../config";

export function requestInterceptor() {
  axios.interceptors.request.use(
    function (config) {
      config.url = `${BACKEND_HOST}${config.url}`;
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );
}
